import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  orderedProducts: {
    id: '/wb59I',
    defaultMessage: 'Ordered Products',
    description: 'Header for the ordered products section in the purchase order page',
  },
  totalReceived: {
    defaultMessage: 'Total received: {totalReceived}/{totalOrdered}',
    id: 'bqCxdJ',
    description: 'Total received text',
  },
  summary: {
    defaultMessage: 'Showing 1-{total} of {total} items',
    id: '+Xc9sb',
    description: 'Product summary text',
  },
  noProductsPlaceholder: {
    defaultMessage: 'No products in this order',
    id: 'EpN0MN',
    description: 'No products placeholder text',
  },
});
